import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Abstract role service.
 * Provides an interface for role management that can be implemented
 * differently for production (OAuthService) and mock environments (MockService).
 */
@Injectable()
export abstract class RoleService {
  abstract readonly userRoles$: BehaviorSubject<string[]>;

  abstract updateRolesFromToken(): void;
  abstract getUserRoles$(): BehaviorSubject<string[]>;

  /**
   * Returns the current logged-in user's Keycloak UUID (JWT sub claim).
   * Used to determine if the caller is editing their own record.
   */
  abstract getCallerUserId(): string;

  /**
   * Formats a role name for display purposes.
   * Converts kebab-case and snake_case to Title Case.
   * @param role The role name to format
   * @returns The formatted role name
   */
  formatRoleName(role: string): string {
    return role
      .replace(/[-_]/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
